import { render, staticRenderFns } from "./Boxed.vue?vue&type=template&id=00426ba0"
import script from "./Boxed.vue?vue&type=script&lang=js"
export * from "./Boxed.vue?vue&type=script&lang=js"
import style0 from "./Boxed.vue?vue&type=style&index=0&id=00426ba0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports